import { Component } from "@angular/core";
import * as moment from "moment";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-manage-all-firmware",
	templateUrl: "./manage-all-firmware.component.html",
	styleUrls: ["./manage-all-firmware.component.scss"]
})
export class ManageAllFirmwareComponent {
	constructor(public api: ApiService) { }

	public ignoreMyOrg = true;

	async DownloadFirmware() {
		await this.api.ExportFirmware("Foresight FW "+ moment().format("YYYY-MM-DD HHmmss") + ".csv", this.ignoreMyOrg ? this.api.user.organization_id : undefined);
	}
}
